import { render, staticRenderFns } from "./ExternalWidgetViewer.vue?vue&type=template&id=a875737e&scoped=true"
import script from "./ExternalWidgetViewer.vue?vue&type=script&lang=js"
export * from "./ExternalWidgetViewer.vue?vue&type=script&lang=js"
import style0 from "./ExternalWidgetViewer.vue?vue&type=style&index=0&id=a875737e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a875737e",
  null
  
)

export default component.exports